export const purchaseUrls = {
  gap: 'https://www.compradigitalya.com/cart/43001977765959:1',
  complete: 'https://www.compradigitalya.com/cart/43001978126407:1',
}

export const testimonials = [
  {
    initials: 'AG',
    name: 'Agustina G.',
    place: 'Buenos Aires, Argentina · 27 años · Instructora GAP',
    text: 'El primer día usé la activación de glúteos del Tomo 1 y mis alumnas lo notaron enseguida. Dejé de repetir ejercicios sin sentido y ahora cada clase tiene una progresión clara.',
  },
  {
    initials: 'PV',
    name: 'Paula V.',
    place: 'San Juan, Argentina · 36 años · Profesora de Educación Física',
    text: 'Trabajo con grupos grandes y planificar me agotaba. Con la Biblioteca de Clases elijo el formato, adapto los elementos y salgo a dar clase tranquila. Me devolvió muchísimo tiempo.',
  },
  {
    initials: 'NR',
    name: 'Noelia R.',
    place: 'Tucumán, Argentina · 33 años · Entrenadora personal',
    text: 'El Desafío GAP fue un antes y un después para mi comunidad. Las alumnas siguieron el calendario, compartieron avances y varias renovaron el mes siguiente sin que yo tuviera que insistir.',
  },
]

export const tomos = [
  {
    icon: '📘',
    name: 'GAP Principiantes',
    period: 'El Cimiento Técnico',
    content: [
      '80+ ejercicios con técnica completa para glúteos, abdomen y piernas',
      'Protocolo de activación neuromuscular de glúteo desde el día uno',
      'Clases de 30, 45 y 60 minutos listas para dictar',
    ],
  },
  {
    icon: '📗',
    name: 'GAP Intermedio',
    period: 'La Evolución del Movimiento',
    content: [
      'Superseries, circuitos y métodos de intensificación sin máquinas',
      'Programas de 4 y 8 semanas listos para implementar',
      'Activación avanzada y progresión de carga real',
    ],
  },
  {
    icon: '📙',
    name: 'GAP Avanzado',
    period: 'El Límite del Rendimiento',
    content: [
      'Triseries, HIIT, AMRAP y EMOM aplicados al GAP',
      'Programación de 12 semanas completa',
      'Clases de alta exigencia para alumnos que piden más',
    ],
  },
  {
    icon: '📕',
    name: 'Biblioteca de Clases',
    period: 'Plug & Play',
    content: [
      '30 clases listas para dictar: grupales e individuales',
      'Con step, bandas, mancuernas y sin elementos',
      'Formato simple: abrís, leés y ejecutás',
    ],
  },
  {
    icon: '📓',
    name: 'Biblioteca de Rutinas',
    period: 'El Especialista',
    content: [
      'Rutinas por objetivo: tonificar, fuerza y resistencia',
      'Sistema de doble progresión y tabla de sustitución de elementos',
      'Planificador anual completo incluido',
    ],
  },
]

export const bonuses = [
  ['01', '🏠', 'GAP en Casa', 'Rutinas de 20, 30 y 45 minutos con peso corporal puro. Incluye un plan de 4 semanas y clases enviables por WhatsApp para alumnas que no pueden ir al gimnasio.', '$12.000'],
  ['02', '🥗', 'Guía de Alimentación', 'Menús, recetas y listas de compras para tonificar, perder grasa y ganar masa muscular, con ingredientes accesibles en Argentina y plantilla semanal.', '$14.000'],
  ['03', '🔄', 'Movilidad y Activación', 'Protocolos de entrada en calor para clases suaves, medias e intensas. Activación de glúteos, core y piernas con 20 combinaciones listas.', '$12.000'],
  ['04', '🧘', 'Estiramiento y Recuperación', 'Vuelta a la calma de 3 a 15 minutos, estiramientos por músculo y 30 frases de cierre listas para usar al final de cada clase.', '$10.000'],
  ['05', '🏆', 'Desafío GAP', 'Desafíos de 7, 21 y 30 días para lanzar en gimnasio o WhatsApp: calendarios imprimibles, mensajes diarios y dinámicas grupales incluidas.', '$12.000'],
] as const

export const faqs = [
  ['¿Sirve si recién empiezo con clases GAP?', 'Sí. El Tomo 1 te da toda la base técnica antes de tu primera clase. Podés empezar desde cero y dar clases profesionales desde el primer día.'],
  ['¿Cómo recibo el material?', 'Una vez confirmado el pago, recibís acceso por email en menos de 5 minutos. Descargás los PDFs y los usás desde cualquier dispositivo, incluso sin conexión.'],
  ['¿La garantía es real?', 'Sí. Tenés 7 días para probarlo. Si no te sirve, escribís a compradigitalyaa@gmail.com y te devolvemos el 100% sin preguntas.'],
  ['¿Funciona para grupos e individuales?', 'Sí. El Tomo 4 tiene clases para grupos de hasta 35 personas y el Tomo 5 incluye rutinas para personalizar sesiones individuales.'],
  ['¿Qué necesito para empezar?', 'Solo internet para descargar los archivos. Después funcionan offline. No necesitás equipamiento especial: el Tomo 1 arranca con peso corporal puro.'],
  ['¿Las clases incluyen ejercicios sin equipamiento?', 'Sí. El sistema ofrece alternativas con peso corporal, bandas, step y mancuernas. Además, GAP Home Pro amplía el repertorio para entornos sin gimnasio.'],
  ['¿Puedo usarlo para dar clases online?', 'Sí. Con GAP Home Pro recibís 10 clases pensadas para pantalla, ejercicios con objetos del hogar y una programación de 12 semanas sin gimnasio.'],
  ['¿Los desafíos están listos para lanzar?', 'Sí. El Bono Desafío GAP incluye versiones de 7, 21 y 30 días con calendario, mensajes diarios y dinámicas para sostener el compromiso del grupo.'],
  ['¿Está adaptado a profesionales de Argentina?', 'Sí. El contenido, los formatos de clase y los materiales complementarios están pensados para la realidad de profesores e instructores que trabajan en Argentina.'],
  ['¿Puedo imprimir los materiales?', 'Sí. Todo el combo está en PDF y listo para leer desde el celular, guardar en computadora o imprimir para llevar a tus clases.'],
] as const
